import { render } from "./accessWorkers.vue?vue&type=template&id=3507ef7e&scoped=true"
import script from "./accessWorkers.vue?vue&type=script&lang=js"
export * from "./accessWorkers.vue?vue&type=script&lang=js"

import "./accessWorkers.vue?vue&type=style&index=0&id=3507ef7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3507ef7e"]])

export default __exports__